class CartUpsell {
  constructor() {
    this.upsellContainers = document.querySelectorAll(
      "[data-upsell-container], [data-complimentary-container]"
    );
    if (this.upsellContainers.length === 0) return;

    this.initEventListeners();
    this.cart = document.querySelector("cart-drawer");

    // Set up mutation observer to detect cart changes
    this.setupCartObserver();
  }

  initEventListeners() {
    // Remove any existing event listeners first to prevent duplicates
    if (this.clickHandler) {
      this.upsellContainers.forEach((container) => {
        container.removeEventListener("click", this.clickHandler);
      });
    }

    // Store the handler reference so we can remove it later if needed
    this.clickHandler = this.handleClick.bind(this);
    this.upsellContainers.forEach((container) => {
      container.addEventListener("click", this.clickHandler);
    });
  }

  setupCartObserver() {
    // Create a MutationObserver to watch for changes to the cart drawer
    if (!this.observer && this.cart) {
      this.observer = new MutationObserver((mutations) => {
        // Check if our upsell containers are still in the DOM
        const newUpsellContainers = document.querySelectorAll(
          "[data-upsell-container], [data-complimentary-container]"
        );

        if (newUpsellContainers.length !== this.upsellContainers.length) {
          // The upsell containers were replaced, update our reference and re-initialize
          this.upsellContainers = newUpsellContainers;
          this.initEventListeners();
          console.log(
            "Cart upsell containers changed, re-initialized listeners"
          );
        }
      });

      // Start observing the cart drawer for content changes
      this.observer.observe(this.cart, {
        childList: true,
        subtree: true,
      });
    }
  }

  handleClick(event) {
    const addButton = event.target.closest("[data-upsell-add-button]");
    if (!addButton) return;

    const upsellItem = addButton.closest("[data-upsell-item]");
    const variantId = upsellItem.querySelector("[data-variant-id]").value;

    this.addToCart(variantId, upsellItem);
  }

  async addToCart(variantId, upsellItem) {
    const addButton = upsellItem.querySelector("[data-upsell-add-button]");
    const loadingEl = upsellItem.querySelector("[data-upsell-loading]");
    const successEl = upsellItem.querySelector("[data-upsell-success]");

    // Show loading state
    addButton.classList.add("hidden");
    loadingEl.classList.remove("hidden");

    // Use the exact same pattern as product-form.js
    const config = fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];

    const formData = new FormData();
    formData.append("id", variantId);
    formData.append("quantity", 1);

    if (this.cart) {
      formData.append(
        "sections",
        this.cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append("sections_url", window.location.pathname);
      this.cart.setActiveElement(document.activeElement);
    }
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          // Handle error case
          console.error("Error adding to cart:", response.description);
          throw new Error(response.description);
        } else if (!this.cart) {
          // If there's no cart drawer, redirect to cart page
          window.location = window.routes.cart_url;
          return;
        }

        // Show success state
        loadingEl.classList.add("hidden");
        successEl.classList.remove("hidden");

        // Update the cart drawer
        this.cart.renderContents(response);

        // After the cart drawer has been updated, check for new upsell containers
        setTimeout(() => {
          const newUpsellContainers = document.querySelectorAll(
            "[data-upsell-container], [data-complimentary-container]"
          );
          if (newUpsellContainers.length !== this.upsellContainers.length) {
            // The containers have changed, update reference and reinitialize
            this.upsellContainers = newUpsellContainers;
            this.initEventListeners();
            console.log("Re-initializing upsell listeners after cart update");
          }
        }, 100);

        // Remove ONLY this specific upsell item from display after a short delay
        setTimeout(() => {
          upsellItem.style.transition = "opacity 0.3s ease-out";
          upsellItem.style.opacity = "0";
          setTimeout(() => {
            // Remove only this specific item
            upsellItem.remove();

            // Only hide the entire section if there are no items left
            this.upsellContainers.forEach((container) => {
              if (
                container.querySelectorAll("[data-upsell-item]").length === 0
              ) {
                const upsellSection = container.closest(".cart-drawer-upsell");
                if (upsellSection) {
                  upsellSection.style.display = "none";
                }
              }
            });
          }, 300);
        }, 800);

        // Publish cart update event
        if (!this.error) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "cart-upsell",
            productVariantId: variantId,
            cartData: response,
          });
        }
      })
      .catch((e) => {
        console.error(e);
        // Show error state or reset
        loadingEl.classList.add("hidden");
        addButton.classList.remove("hidden");

        // Optional: show error message
        this.handleErrorMessage(e.message);
      })
      .finally(() => {
        if (this.cart && this.cart.classList.contains("is-empty")) {
          this.cart.classList.remove("is-empty");
        }

        // Update cart items countdown if applicable
        var CartItems = document.querySelector("cart-drawer-items");
        if (
          CartItems &&
          typeof CartItems.setCountdownOnAllItems === "function"
        ) {
          CartItems.setCountdownOnAllItems();
        }
      });
  }

  handleErrorMessage(errorMessage = "") {
    if (errorMessage) {
      alert(`Error: ${errorMessage}`);
    }
  }

  refreshCart() {
    // If we have a cart-drawer element and we couldn't update it directly in addToCart
    if (document.querySelector("cart-drawer") && !this.cart) {
      const cartDrawer = document.querySelector("cart-drawer");

      // Try to fetch cart data and update the drawer
      fetch("/cart.js")
        .then((response) => response.json())
        .then((cart) => {
          // If there's a specific update function for the cart drawer
          if (typeof cartDrawer.updateContents === "function") {
            cartDrawer.updateContents(cart);
          }
        })
        .catch((error) => console.error("Error refreshing cart:", error));

      return;
    }

    // 1. Check for theme-specific cart update function
    if (typeof window.updateCartDrawer === "function") {
      window.updateCartDrawer();
      return;
    }

    // 2. Try to fetch and replace cart drawer content using Shopify section rendering API
    if (window.Shopify && window.Shopify.routes) {
      fetch(`${window.Shopify.routes.root}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");
          const cartDrawerContent = doc.querySelector(".cart-drawer__content");

          if (cartDrawerContent) {
            const currentCartDrawer = document.querySelector(
              ".cart-drawer__content"
            );
            if (currentCartDrawer) {
              currentCartDrawer.innerHTML = cartDrawerContent.innerHTML;
            }
          }

          // Re-initialize any necessary cart drawer scripts
          if (typeof window.initCartDrawer === "function") {
            window.initCartDrawer();
          }
        });

      return;
    }

    // 3. Dispatch custom event that might be listened for by theme
    document.dispatchEvent(
      new CustomEvent("cart:updated", {
        bubbles: true,
      })
    );

    // 4. Last resort - reload the page
    setTimeout(() => {
      window.location.reload();
    }, 2500);
  }
}

// Initialize when DOM is ready
document.addEventListener("DOMContentLoaded", () => {
  new CartUpsell();
});

// Listen for custom cart update events if your theme fires them
document.addEventListener("cart:updated", () => {
  setTimeout(() => {
    const containers = document.querySelectorAll(
      "[data-upsell-container], [data-complimentary-container]"
    );
    if (containers.length > 0) {
      let upsellInstance = new CartUpsell();

      upsellInstance.initEventListeners();
    }
  }, 100);
});
